<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                :validate-error="errors[0]"
                                v-model="formData.academic_year">
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('semester')" >
                        <div class="d-flex justify-content-center border rounded">
                            <ValidationProvider name="spring" rules="required" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('spring')" class="mr-3">
                                    <b-form-checkbox v-model="formData.spring"></b-form-checkbox>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="fall" rules="required" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('fall')">
                                    <b-form-checkbox v-model="formData.fall"></b-form-checkbox>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="reason" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('leave_of_absence_reason')">
                            <parameter-selectbox
                                v-model="formData.reason"
                                code="leave_of_absence_reasons"
                                :validate-error="errors[0]"
                            />
                            <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="explanation"
                        rules="required|max:200"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('explanation')">
                            <b-form-input
                                v-model="formData.explanation"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="file" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('excuse_file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="formData.file" :placeholder="formData.file?.file_name || formData.file?.name || $t('select_file')"
                                             ref="fileInput"></b-form-file>
                                <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{
                                        $t('browse') }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="formData.status"
                                                 :validate-error="errors[0]" code="leave_of_absence_statuses"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>


<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
import YesNoSelectbox from '@/components/interactive-fields/YesNoSelectbox';
import LeaveOfAbsenceService from "@/services/LeaveOfAbsenceService";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,

        ParameterSelectbox,
        YesNoSelectbox,
    },
    props: {
        formId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            formLoading: false,
            formData: {},
        }
    },
    created() {
        this.getLeaveAbsence()
    },
    methods: {
        decodeHtmlEntities(s) {
            if (!s || typeof s !== 'string') return s;
            return s
                .replace(/&quot;/g, '"')
                .replace(/&#34;/g, '"')
                .replace(/&apos;/g, "'")
                .replace(/&#39;/g, "'")
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>');
        },
        getLeaveAbsence() {
            LeaveOfAbsenceService.get(this.formId)
                .then(response => {
                    this.formData = response.data.data;
                    this.step = this.formData.step == null ? {} : this.formData.step;
                    if (this.formData && this.formData.explanation) {
                        this.formData.explanation = this.decodeHtmlEntities(this.formData.explanation);
                    }
                })
                .catch(e => {
                    this.$toast.error(e.data.message)
                })

        },
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();

            if (isValid) {
                const formData = new FormData();

                formData.append('student_program_id', this.formData.student_program_id || '');
                formData.append('fall', this.formData.fall ? 1 : 0);
                formData.append('spring', this.formData.spring ? 1 : 0);
                formData.append('reason', this.formData.reason || '');
                formData.append('explanation', this.formData.explanation || '');
                formData.append('status', this.formData.status || '');
                formData.append('academic_year', this.formData.academic_year || '');

                if (this.formData.file && this.formData.file.length > 0) {
                    formData.append('file', this.formData.file)
                }

                this.formLoading = true;

                LeaveOfAbsenceService.updateAbsenceData(this.formData.id, formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.$toast.error(this.$t('api.' + e.data.message));
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            }
        }


    }
}
</script>
